export const getNextItem = <T>(arr: T[], currentItemIndex: number) => {
  if (currentItemIndex < 0) {
    throw new Error(`getNextItem got an invalid index of ${currentItemIndex}`)
  }
  if (arr.length - 1 > currentItemIndex) {
    return arr[currentItemIndex + 1]
  }
  return arr[0]
}

export const getNextItemIndex = <T>(arr: T[], currentItemIndex: number) => {
  if (arr.length - 1 > currentItemIndex) {
    return currentItemIndex + 1
  }
  return 0
}

export const getItemIndexThatMeetsCondition = <T>(
  arr: T[],
  currentItemIndex: number,
  condition: (item: T) => boolean,
) => {
  for (var i = 0; i < arr.length; i++) {
    var pointer = (i + currentItemIndex) % arr.length
    if (condition(arr[pointer])) {
      return pointer
    }
  }
  throw new Error(`getItemIndexThatMeetsCondition never met condition with array ${arr}`)
}

export const getItemThatMeetsCondition = <T>(
  arr: T[],
  currentItemIndex: number,
  condition: (item: T) => boolean,
) => {
  for (var i = 0; i < arr.length; i++) {
    var pointer = (i + currentItemIndex) % arr.length
    if (condition(arr[pointer])) {
      return arr[pointer]
    }
  }
  throw new Error(`getItemThatMeetsCondition never met condition with array ${arr}`)
}
